import * as tslib_1 from "tslib";
import onFolderForestNodeSelected from './onFolderForestNodeSelected';
import commandBarAction from 'owa-group-header-store/lib/actions/commandBarAction';
import NavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import { lazyOnSelectedPersonaNodeChanged } from 'owa-mail-favorites-store';
import { lazySetGroupLastVisitedTime } from 'owa-group-left-nav-actions';
import { getGroupIdFromTableQuery } from 'owa-group-common';
import { getSelectedTableView } from 'owa-mail-list-store';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from 'owa-mail-folder-forest-store';
/**
 * Set the selected node in the folder forest
 * @param node node to be selected
 * @param actionSource action that initiated the switch folder action
 * @return a promise that resolves when the select node has completed
 */
export default action('selectNodeInFolderForest')(function selectNodeInFolderForest(node, actionSource) {
    var state = getStore();
    if (state.selectedNode.type === 1 /* Persona */) {
        lazyOnSelectedPersonaNodeChanged.importAndExecute(state.selectedNode);
    }
    if (state.selectedNode.type === 2 /* Group */) {
        /* If switching from Group to another node, set the time last visited for the group.
        This will only be needed while Groups supports both seen/unseen and read/unread on
        different clients. TO-DO 115698: Remove this when legacy clients are no longer using
        seen/unseen and requiring lastVisitedTime */
        var tableView = getSelectedTableView();
        tableView &&
            lazySetGroupLastVisitedTime.importAndExecute(getGroupIdFromTableQuery(tableView.tableQuery));
        // If switching from Group to Folder or other types,
        // reset the Group Header CommandBar state so it shows Conversations tab
        if (node.type != 2 /* Group */) {
            commandBarAction(NavigationButton.Email);
        }
    }
    // Set the selected node properties in folder forest store
    state.selectedNode = tslib_1.__assign({}, node);
    return onFolderForestNodeSelected(state.selectedNode, actionSource);
});
//# sourceMappingURL=selectNodeInFolderForest.js.map